module.exports = global["jQuery"] = require("-!/Users/kshalm/Dropbox/Physics/Code/Javascript/PhasematchJS/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
 ** module id = 305
 ** module chunks = 1
 **/